import { Request } from '../../httpClient/serverApi/requests/Request';
import { IFavorite } from '../../ts/ServerApi/types/IFavorite';
import { IGetItemsParams } from '../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../ts/ServerApi/types/IGetItemsResult';

export interface IGetFavoritesResult extends IGetItemsResult {
  favorites: IFavorite[];
}

export class GetFavoritesRequest extends Request<IGetItemsParams, IGetFavoritesResult> {
  constructor(params: IGetItemsParams) {
    super('getFavorites', params);
  }
}
